import React from 'react';
import styled from 'styled-components';
import { Tooltip } from '@mui/material';
import { ReactComponent as InfoIconBase } from '../../assets/information-icon.svg';
import { Flex } from '../Flex';
import { componentToken } from '../../style/utils';

const InformationIcon = styled(InfoIconBase)<{ size?: number }>`
  width: ${({ size }) => size || 18}px;
  height: ${({ size }) => size || 18}px;

  > path {
    fill: ${componentToken('tooltip.informationIcon.pathFill')};
  }

  &:hover {
    > path {
      fill: ${componentToken('tooltip.informationIcon.hoverPathFill')};
    }
  }
`;

const InfoTooltip = ({
  title,
  size,
}: {
  title: React.ReactNode;
  size?: number;
}) => (
  <Tooltip title={title}>
    <Flex>
      <InformationIcon size={size} />
    </Flex>
  </Tooltip>
);

export default InfoTooltip;
